import script from "./mosuannai.vue?vue&type=script&setup=true&lang=js"
export * from "./mosuannai.vue?vue&type=script&setup=true&lang=js"

import "./mosuannai.vue?vue&type=style&index=0&id=2433bd3c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2433bd3c"]])

export default __exports__